// components/LoadingSpinner.jsx
export default function LoadingSpinner({ size = 'md', fullScreen = false }) {
  const sizes = { sm: 'w-4 h-4 border-2', md: 'w-7 h-7 border-2', lg: 'w-10 h-10 border-3' };
  const spinner = <div className={`${sizes[size]} border-onb-green border-t-transparent rounded-full animate-spin`} />;
  if (fullScreen) return (<div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[100]"><div className="flex flex-col items-center gap-3">{spinner}<p className="text-onb-green text-xs animate-pulse tracking-widest">onbank loading...</p></div></div>);
  return spinner;
}
